import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 높이 56px — 시안 h-14 고정. */
export const headerStyle = css`
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 ${theme.space.lg}px;
  background: ${theme.color.surface};
  border-bottom: 1px solid ${theme.color.border};
`;

export const titleStyle = css`
  margin: 0;
  font-size: ${theme.fontSize.lg}px;
  font-weight: 600;
  color: ${theme.color.text};
`;

/* 제목 + DEV 배지를 한 줄로 묶는 좌측 영역. */
export const titleGroupStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  min-width: 0;
`;

/* 개발 환경 배지 — 운영과 확연히 구분되도록 danger 톤 pill. */
export const devBadgeStyle = css`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  border-radius: ${theme.radius.pill}px;
  background: ${theme.color.secondary};
  color: ${theme.color.onPrimary};
  font-size: ${theme.fontSize.sm}px;
  font-weight: 700;
  letter-spacing: 0.03em;
  white-space: nowrap;
`;

/* 배지 안 API base 표기 — 살짝 투명하게. */
export const devBadgeApiStyle = css`
  font-weight: 500;
  opacity: 0.85;
  font-variant-numeric: tabular-nums;
`;

export const rightStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  font-size: ${theme.fontSize.md}px;
`;

export const mutedStyle = css`
  color: ${theme.color.textMuted};
`;

export const dividerStyle = css`
  width: 1px;
  height: ${theme.space.lg}px;
  background: ${theme.color.border};
`;
